<template>
    <b-standard-card
        :title="translations.title[lang]"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :loading="loading"
        class="mt-5"
        height="auto"
        max-height="80"
        :error-message="errorMessage"
        @submit="openDialog"
    >
        <v-row>
            <v-col class="pb-0">
                {{ translations.type0forInfinite[lang] }}
            </v-col>
            <v-col md="12" style="color: black;" class="d-flex flex-row align-center"
                >
                <span class="text-subtitle-2">
                {{ translations.description1[lang] }}
            </span>
                <v-text-field
                    style="max-width: 70px;"
                    class="pr-1 pl-1"
                    type="number"
                    inputmode="numeric"
                    v-model="inactiveDays"
                    outlined
                    solo
                    dense
                    color="secondary"
                    hide-details
                    erro
                    @keypress="onlyIntegerNumbers"
                    @change="validateInt()"
                ></v-text-field>
                <span class="text-subtitle-2">
                {{ translations.description2[lang] }}
            </span>
            </v-col>
           
        </v-row>
      
        <v-dialog
                v-model="dialog"
                :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '40%'"
            >
            <b-card
                :title="translations.title[lang]"
                :submit-text="translations.delete"
                :loading="loading"
                @cancel="dialog = false"
                @submit="saveData"
            >
                <div v-if="inactiveDays" class="subtitle-1 font-weight-medium pt-2 px-2">
                    {{ translations.description1[lang] }}
                    <span class="font-weight-bold text--primary">{{
                        expiration_points.expiration_days_inactive
                    }}</span
                    >{{ translations.description2[lang] }}
                </div>
                <div v-else class="subtitle-1 font-weight-medium pt-2 px-2" v-html="translations.neverExpire[lang]">
                </div>
            </b-card>
            </v-dialog>
    </b-standard-card>
</template>

<script>
import translations from "@/utils/translations/loyaltyPanel/businessProfile/pointExpiration";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { cloneDeep } from "lodash";
import { onlyIntegerNumbers } from "@/utils/helpers";

export default {
    name: "PointExpiration",

    mixins: [translations],

    data() {
        return {
            initialValues: {},
            dialog: false
        }
    },
    computed: {
       
        lang() {
            return this.$route.params.lang;
        },
        loading() {
            return this.$store.state.loyaltyPanel.businessProfile.loading
                .expiration_points;
        },

        errorMessage() {
            return this.$store.state.loyaltyPanel.businessProfile.errorMessage
                .expiration_points;
        },
        resetSuccess() {
            return this.$store.state.loyaltyPanel.businessProfile.resetSuccess
                .expiration_points;
        },

        ...mapState("loyaltyPanel/businessProfile", [
            "expiration_points"
        ]),

        inactiveDays: {
            get() {
                return this.expiration_points.expiration_days_inactive ;
            },
            set(val) {
                this.setExpirationPoints({...this.expiration_points, expiration_days_inactive: val});
                
            }
        }
    },
    methods: {
        ...mapActions("loyaltyPanel/businessProfile", [
            "updateExpirationPoints"
        ]),
        ...mapMutations("loyaltyPanel/businessProfile", [
            "setExpirationPoints"
        ]),
        onlyIntegerNumbers,

        openDialog(){
            this.dialog = true
        },
        validateInt(val = this.inactiveDays){
            if (!val && (val !==0 || val!=='0') || val < 0 ){
                    this.inactiveDays = 0
                }
                if (val?.length) {
                    this.inactiveDays = parseInt(val.replace(/\D+/g, ''))
                }
                
        },
        async saveData() {
            await this.updateExpirationPoints({
                    type: 'expiration_points',
                    body: {...this.expiration_points}
                })
                this.dialog = false
        }
    },

    mounted() {
        this.initialValues = cloneDeep(this.expiration_points)
        this.validateInt()
    }
   
};
</script>

